var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickTierIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#4D8AFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6164 12.3211L14.5118 21.516C13.8989 22.1613 12.8484 22.1613 12.2356 21.516L8.38362 17.5638C7.85838 16.9992 7.85838 16.112 8.47116 15.5474C9.08399 15.0634 10.047 15.0634 10.6598 15.628L13.3737 18.451L21.3402 10.4659C21.953 9.90132 22.916 9.82067 23.5288 10.3853C24.1416 10.8692 24.1416 11.8371 23.6164 12.3211Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickTierIcon);
export default __webpack_public_path__ + "static/media/tick-tier-icon.bc6aab11607e7574025ffbf4d63b1063.svg";
export { ForwardRef as ReactComponent };